// collection is like a table in relational database

const COLLECTION_USERS = "users";
const COLLECTION_SHOPPING_CART = "shopping_cart";
const COLLECTION_BANNERS = "banners";
const COLLECTION_PRODUCTS = "products";
const COLLECTION_ORDERS = "orders";

export {
  COLLECTION_USERS,
  COLLECTION_SHOPPING_CART,
  COLLECTION_BANNERS,
  COLLECTION_PRODUCTS,
  COLLECTION_ORDERS,
};
